import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import TextArea from 'react-textarea-autosize'

// Styles
import styles from './ExpandablePillTextField.module.scss'

const ExpandablePillTextField = ({
  name,
  placeholder,
  className,
  value,
  onChange,
  maxRows,
  ...restProps
}) => {
  return (
    <TextArea
      className={classnames(styles.textArea, className)}
      value={value}
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      maxRows={maxRows}
      {...restProps}
    />
  )
}

ExpandablePillTextField.defaultProps = {
  placeholder: 'Type your question...',
}

ExpandablePillTextField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  maxRows: PropTypes.number,
}

export default ExpandablePillTextField
